export default "__VITE_PUBLIC_ASSET__a42955ed__"